import { ApiResponse } from 'apisauce';
import { IPaginationSnapshot } from 'src/models/pagination/Pagination';

import { IReport, IReportSnapshot, ReportFilter, ReportSaveDto } from '../../models';
import { Api } from '../api/api';
import { getGeneralApiProblem } from '../api/api-problem';

import {
  TDeleteReportResult,
  TGetReportResult,
  TGetReportsResult,
  TSaveReportResult,
} from './ReportTypes';

/**
 * # Report Api 서비스
 *
 * 서비스의 설명을 작성하세요.
 *
 * ## 사용방법
 *
 * ```ts
 * const service = new ReportApi();
 *
 * ```
 */
export class ReportApi {
  private api: Api;

  constructor(api: Api) {
    this.api = api;
  }

  async gets(filter?: ReportFilter): Promise<TGetReportsResult> {
    try {
      const url = '/report';
      const params = { ...filter };
      const response: ApiResponse<any> = await this.api.apisauce.get(url, params);

      if (!response.ok) {
        const problem = getGeneralApiProblem(response);
        if (problem) return problem;
      }

      const reports: IReport[] = response.data.data;
      const pagination: IPaginationSnapshot = response.data.pagination;
      const responseInfo = response.data;
      return { kind: 'ok', reports, pagination, responseInfo };
    } catch (e) {
      return { kind: 'bad-data' };
    }
  }

  async get(reportSid: number | 'generate'): Promise<TGetReportResult> {
    try {
      const url = `/report/${reportSid}`;
      const params = {};
      const response: ApiResponse<any> = await this.api.apisauce.get(url, params);

      if (!response.ok) {
        const problem = getGeneralApiProblem(response);
        if (problem) return problem;
      }

      const report: IReport = response.data.data;
      const responseInfo = response.data;
      return { kind: 'ok', report, responseInfo };
    } catch (e) {
      return { kind: 'bad-data' };
    }
  }

  async checkDate(date: { year: string; month: string }): Promise<TGetReportResult> {
    try {
      const url = `/report/checkDate/${date.year}/${date.month}`;
      const response: ApiResponse<any> = await this.api.apisauce.get(url);

      if (!response.ok) {
        const problem = getGeneralApiProblem(response);
        if (problem) return problem;
      }

      const report: IReport = response.data.data;
      const responseInfo = response.data;
      return { kind: 'ok', report, responseInfo };
    } catch (e) {
      return { kind: 'bad-data' };
    }
  }

  async save(newReport: ReportSaveDto): Promise<TSaveReportResult> {
    try {
      const hasSid = !!newReport.reportSid;
      const url = hasSid ? `/report/${newReport.reportSid}` : '/report';
      const method = hasSid ? this.api.apisauce.put : this.api.apisauce.post;
      const response: ApiResponse<any> = await method(url, newReport);
      if (!response.ok) {
        const problem = getGeneralApiProblem(response);
        if (problem) return problem;
      }
      const report: IReport = response.data.data;
      const responseInfo = response.data;
      return { kind: 'ok', report, responseInfo };
    } catch (e) {
      return { kind: 'bad-data' };
    }
  }

  async downloadPdf(reportSid: number): Promise<any> {
    try {
      const url = `/report/pdfDownload/${reportSid}`;
      const response: ApiResponse<any> = await this.api.apisauce.get(
        url,
        {},
        { responseType: 'blob' },
      );
      if (!response.ok) {
        const problem = getGeneralApiProblem(response);
        if (problem) return problem;
      }
      const pdf = response.data;
      const responseInfo = response.data;
      return { kind: 'ok', pdf, responseInfo };
    } catch (e) {
      return { kind: 'bad-data' };
    }
  }

  // async post(): Promise<TPostReportResult> {
  //   try {
  //     const url = '/report';
  //     const payload = {};
  //     const response: ApiResponse<any> = await this.api.apisauce.post(url, payload);

  //     if (!response.ok) {
  //       const problem = getGeneralApiProblem(response);
  //       if (problem) return problem;
  //     }

  //     const report: IReport = response.data.data;
  //     const responseInfo = response.data;
  //     return { kind: 'ok', report, responseInfo };
  //   } catch (e) {
  //     return { kind: 'bad-data' };
  //   }
  // }

  // async update(id: number): Promise<TUpdateReportResult> {
  //   try {
  //     const url = `/report/${id}`;
  //     const payload = {};
  //     const response: ApiResponse<any> = await this.api.apisauce.put(url, payload);

  //     if (!response.ok) {
  //       const problem = getGeneralApiProblem(response);
  //       if (problem) return problem;
  //     }

  //     const report: IReport = response.data.data;
  //     const responseInfo = response.data;
  //     return { kind: 'ok', report, responseInfo };
  //   } catch (e) {
  //     return { kind: 'bad-data' };
  //   }
  // }

  async delete(id: number): Promise<TDeleteReportResult> {
    try {
      const url = `/report/${id}`;
      const payload = {};
      const response: ApiResponse<any> = await this.api.apisauce.delete(url, payload);

      if (!response.ok) {
        const problem = getGeneralApiProblem(response);
        if (problem) return problem;
      }
      const responseInfo = response.data;
      return { kind: 'ok', responseInfo };
    } catch (e) {
      return { kind: 'bad-data' };
    }
  }
}
